<cap-oereb-wrapper
  [gsId]="gsId"
  [hasData]="hasData"
  [oerebServiceNichtVerfuegbar]="oerebServiceNichtVerfuegbar"
  [stockwerkOrMiteigentum]="stockwerkOrMiteigentum">
  @if (stammgrundstueck$ | async; as stammgrundstueck) {
    <p>
      {{ "oereb.datenVonGrundstueck:" | translate }}
      <cap-kompakt-grundstueck [item]="stammgrundstueck" [navigateTo]="navTargets.NAV_GRUNDSTUECK_OEREB"></cap-kompakt-grundstueck>
    </p>
  }
  <cap-list-loader [keineTranslateKey]="'oereb.KeineOderNochKeineDatenVorhanden'" [listLoader]="listLoader" [showTotal]="false">
    <div class="cap-list-loader-title">
      <h3>{{ "oereb.oerebsBetreffenGrundstueck" | translate }}</h3>
    </div>
    <div class="cap-list-loader-content">
      <table class="cap-table-detail">
        <tbody>
          <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
        </tbody>
      </table>
    </div>
  </cap-list-loader>
</cap-oereb-wrapper>

<ng-template #tableRows>
  @for (line of listLoader?.items; track line) {
    <tr>
      <td>{{ line }}</td>
    </tr>
  }
</ng-template>
